/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension" endpoint.
 * Returns the schema for a specific dimension, including its fields metadata used for dynamic DataTable column generation.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension,
  (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      dimension,
      environment,
    }: GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/dimensions/${dimension}`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionResult
);
